export const marketingEvents = {
    STORE_CHANGED: 'Store Changed'
}